import { getEkardoApolloClient } from '@netfront/common-library';
import {
  ISearchDirectoriesQueryGraphQLResponse,
  ISearchDirectoriesQueryVariables,
  SEARCH_DIRECTORIES_QUERY,
} from '@netfront/ekardo-content-library';
import { NextPage } from 'next';

import { FeaturesPage, FeaturesPageProps } from '../components/Pages/FeaturesPage';
import { FEATURES_DIRECTORY_PRODUCTION_ID } from '../components/Pages/FeaturesPage/FeaturesPage.constants';
import { STATIC_PAGE_REGENERATION_TIME_IN_SECONDS } from '../constants';

const FeaturesNextPage: NextPage<FeaturesPageProps> = ({ featuresDirectory }: FeaturesPageProps) => {
  return <FeaturesPage featuresDirectory={featuresDirectory} />;
};

export async function getStaticProps() {
  const client = getEkardoApolloClient({
    product: 'KANZI',
  });

  const {
    data: {
      directory: { searchDirectories: featuresDirectory },
    },
  } = await client.query<ISearchDirectoriesQueryGraphQLResponse, ISearchDirectoriesQueryVariables>({
    query: SEARCH_DIRECTORIES_QUERY,
    variables: {
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      directoryTypeId: FEATURES_DIRECTORY_PRODUCTION_ID,
    },
  });

  return {
    props: {
      featuresDirectory: [...featuresDirectory].reverse(),
    },
    revalidate: STATIC_PAGE_REGENERATION_TIME_IN_SECONDS,
  };
}

// eslint-disable-next-line import/no-default-export
export default FeaturesNextPage;
